interface TextBox {
  title: string;
  description: string;
  items?: string[];
}

interface ContentSection02Props {
  image: string;
  imageAlt?: string;
  textBoxes: TextBox[];
}

export const ContentSection02 = ({
  image,
  imageAlt = 'content-image',
  textBoxes
}: ContentSection02Props) => {
  return (
    <section className="pt--100 pt-[100px] lg:max-xl:pt-[80px] md:max-lg:pt-[70px] ct-02 content-section division">
      <div className="container">
        {/* SECTION CONTENT (ROW) */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] items-center">
          {/* IMAGE BLOCK */}
          <div className="xl:w-6/12 lg:max-xl:w-6/12 md:max-lg:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="img-block !text-center left-column wow fadeInRight mr-[30px] lg:max-xl:mr-[5px] md:max-lg:mr-0 sm:max-md:mx-[3%] xsm:max-sm:m-[0_2%_35px]">
              <img className="img-fluid" src={image} alt={imageAlt} />
            </div>
          </div>
          {/* TEXT BLOCK */}
          <div className="xl:w-6/12 lg:max-xl:w-6/12 md:max-lg:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="txt-block right-column wow fadeInLeft">
              {textBoxes.map((box, index) => (
                <div
                  key={index}
                  className={`txt-box ${index === textBoxes.length - 1 ? '!mb-0' : '!mb-[20px] md:max-lg:!mb-[5px]'}`}
                >
                  {/* Title */}
                  <h5 className="s-24 w--700 xl:!text-[1.5rem] lg:max-xl:!text-[1.375rem] md:max-lg:!text-[1.470588rem] sm:max-md:!text-[1.625rem] xsm:max-sm:!text-[1.4375rem] !font-bold leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[20px] lg:max-xl:!mb-[18px] md:max-lg:!mb-[18px] sm:max-md:!mb-[18px]">
                    {box.title}
                  </h5>
                  {/* Text */}
                  <p>{box.description}</p>
                  {/* List */}
                  {box.items && box.items.length > 0 && (
                    <ul className="simple-list">
                      {box.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="list-item">
                          <p
                            className={
                              itemIndex === box.items!.length - 1 ? '!mb-0' : ''
                            }
                          >
                            {item}
                          </p>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/* END TEXT BLOCK */}
        </div>
        {/* END SECTION CONTENT (ROW) */}
      </div>
      {/* End container */}
    </section>
  );
};
